/**
 * Method to delete a cookie by setting it's expiry to the past
 * @param   {string} name
 * @returns {void}
 */
export function deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; `;
}
